<template>
  <el-dialog width="698px" title="生成激活码"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="generateAuthCodeVisible">
    <div class="details">

      <el-form  ref="currencyForm"  size="small" v-loading="loading"   label-position="top"   label-width="100px"  :model="currencyForm"  :rules="currencyFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="license_id" label="产品名称">
              <el-input   v-model="productName" disabled  placeholder="请输入产品名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="date" label="本次授权截止时间">
              <el-date-picker
                :append-to-body="false"
                v-model="currencyForm.date"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
              <p class="range_hint" v-if="orderRangeText">可选范围：{{ orderRangeText }}</p>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="value_code" label="">
              <div class="offline_setting">
                <el-checkbox v-model="offlineTime">定期联网验证</el-checkbox>
                <div v-if="offlineTime" class="offline_input">
                  连续离线每
                  <el-input-number
                    v-model="currencyForm.value_code"
                    :max="99"
                    :min="1"
                    :controls="false"
                    size="small" />
                  天需要联网验证一次
                </div>
                <div v-else class="offline_tip">提示：未启用联网验证，激活码将无法回收，无法找回</div>
              </div>
              <p v-if="offlineTime" class="range_hint">只能填入正整数，最小为1，最大为99。</p>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">生成激活码</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { adminGenLicenseCode, adminUserProductDetail } from '@/api/api'
import { convertToCurrentTimezone, convertToUTC } from '@/utils'
import {mapState} from "vuex";
export default {
  name: 'generate_auth_code',
  props: {
    generateAuthCodeVisible: {
      type: Boolean,
      default: false,
    },
    licenseId: {
      type: Number,
      default: 0,
    },
    productName: {
      type: String,
      default: '',
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      offlineTime: true,
      orderRangeText: '',
      productDetail: {},
      currencyForm:{
       license_id: "",
       date:"",
       license_module_id: '',
       value_code: 7,
      },
      currencyFormRules:{
        license_id:[{ required: true, message: '请选择', trigger: 'change'}],
        date:[{ required: true, message: '请选择本次授权截止时间', trigger: 'change'}],
        value_code:[{ required: true, trigger: 'change', validator: (rule, value, callback) => {
          if (this.offlineTime && (!Number.isInteger(Number(value)) || Number(value) < 1 || Number(value) > 99)) {
            return callback(new Error('请输入1-99的正整数'))
          }
          callback()
        }}],
      },
      pickerOptions: {
        disabledDate: (time) => {
          const order = this.productDetail.order
          if (order && order.start_date && order.end_date) {
            return time.getTime() < new Date(convertToCurrentTimezone(order.start_date, '-', 'datetime')).getTime()
              || time.getTime() > new Date(convertToCurrentTimezone(order.end_date, '-', 'datetime')).getTime()
          }
          return false
        }
      }
    }
  },

  created() {
    if(this.licenseId){
      this.currencyForm.license_id = this.licenseId
      this.getProductDetail()
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    getProductDetail() {
      this.loading = true
      adminUserProductDetail({ id: this.licenseId }).then(res => {
        if (res.code === 200) {
          this.productDetail = res.data || {}
          const order = this.productDetail.order
          if (order && order.start_date && order.end_date) {
            this.currencyForm.date = [
              convertToCurrentTimezone(order.start_date, '-', 'datetime'),
              convertToCurrentTimezone(order.end_date, '-', 'datetime')
            ]
            this.orderRangeText = `${convertToCurrentTimezone(order.start_date, '/', 'datetime')} ~ ${convertToCurrentTimezone(order.end_date, '/', 'datetime')}`
          }

          const offlineModule = (this.productDetail.license_modules || []).find(item => item.module_code == '13')
          if (offlineModule) {
            const valueCode = Number(offlineModule.value_code)
            this.offlineTime = valueCode !== 0
            this.currencyForm.value_code = valueCode > 0 ? valueCode : 7
            this.currencyForm.license_module_id = offlineModule.id
          }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          let postData = {
            license_id: this.currencyForm.license_id,
            start_date: convertToUTC(this.currencyForm.date[0], 'datetime'),
            end_date: convertToUTC(this.currencyForm.date[1], 'datetime'),
            license_module_id: this.currencyForm.license_module_id,
            value_code: this.offlineTime ? this.currencyForm.value_code : 0,
            module_value: this.offlineTime ? `${this.currencyForm.value_code}天` : '无需在线校验'
          }
          this.BtnDisabled = true
          adminGenLicenseCode(postData).then(res => {
            if (res.code === 200) {
              this.BtnDisabled = false
              this.$emit('success',{product_name:this.productName,license_code:res.data.license_code})
              this.$emit('update:generateAuthCodeVisible', false)
            }else{
              this.BtnDisabled = false
            }
          }).catch((e) => {
            this.BtnDisabled = false
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:generateAuthCodeVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.tips{
  line-height: 24px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
.offline_setting {
  display: flex;
  align-items: center;
}
.offline_input,
.offline_tip {
  margin-left: 30px;
}
.offline_input ::v-deep .el-input-number {
  width: 100px;
  margin: 0 8px;
}
::v-deep .el-input-number{
  .el-input__inner{
    text-align: left;
  }
}
::v-deep .el-date-editor--datetimerange{
  width: 100%;

}

</style>
